import React, { createContext, ReactNode, useContext } from "react";
import { ApplicationStatus } from "../interfaces/enums";
import { ApplicationWithId } from "../interfaces/IApplications";

// Interfejs dla wyniku operacji
interface OperationResult {
  success: boolean;
  error?: string;
  application?: ApplicationWithId;
}

interface ApplicationContextType {
  application: ApplicationWithId | null;
  updateApplication: (
    applicationId: string,
    updatedData: Partial<ApplicationWithId>,
  ) => Promise<OperationResult>;
  refreshApplication: (userId: string, applicationId: string) => void;
  updateApplicationStatus: (status: ApplicationStatus) => Promise<OperationResult>;
}

const ApplicationContext = createContext<ApplicationContextType | undefined>(undefined);

export default function ApplicationProvider({
  application,
  updateApplication,
  refreshApplication,
  updateApplicationStatus,
  children,
}: {
  application: ApplicationWithId;
  updateApplication: (
    applicationId: string,
    updatedData: Partial<ApplicationWithId>,
  ) => Promise<OperationResult>;
  refreshApplication: (userId: string, applicationId: string) => void;
  updateApplicationStatus: (status: ApplicationStatus) => Promise<OperationResult>;
  children: ReactNode;
}) {
  return (
    <ApplicationContext.Provider
      value={{
        application,
        updateApplication,
        refreshApplication,
        updateApplicationStatus,
      }}
    >
      {children}
    </ApplicationContext.Provider>
  );
}

export const useApplicationContext = (): ApplicationContextType => {
  const context = useContext(ApplicationContext);
  if (context === undefined) {
    throw new Error(
      "Błąd w ApplicationContext: useApplicationContext must be used within an ApplicationProvider",
    );
  }
  return context;
};
